var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgApLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223.015,
    height: 53.108,
    viewBox: "0 0 223.015 53.108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0.462 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0.038 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M235.35,285.7a36.835,36.835,0,0,0,2.071,5.3,3.436,3.436,0,0,0,2.8.981v.945c-1.381,0-2.8-.073-4.178-.073-1.78,0-3.524.036-5.3.073v-.945h.654c.908,0,2-.181,2-1.2a9,9,0,0,0-.545-2.107l-1.816-5.268h-8.538l-.8,2.543a17.563,17.563,0,0,0-.981,4.323c0,1.707,1.2,1.635,2.471,1.707h.835v.945c-1.417,0-2.87-.073-4.287-.073-1.453,0-2.943.036-4.4.073v-.945c2.216-.254,2.616-.545,3.524-2.579.581-1.308,1.017-2.725,1.489-4.069L225,272.366a11.069,11.069,0,0,0,.763-3.27,3.84,3.84,0,0,0-.073-.945,4.5,4.5,0,0,0,2.107-1.6h.618ZM223,281.921h7.484l-3.887-10.681h-.073Z",
    transform: "translate(-215.332 -266.553)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M289.8,294.128h-.835l-19-20.853v13.551c0,5.014.4,6.03,4.323,6.03v.945c-1.6,0-3.233-.073-4.832-.073s-3.233.036-4.832.073v-.945c2.216,0,3.888,0,3.888-4.613v-14.6c0-3.125-1.344-4.251-4.469-4.251v-.945c1.126.036,2.216.072,3.343.072.981,0,2-.072,2.979-.073,1.49,2.216,4.868,5.522,9.01,10.1,3.089,3.415,6.5,7.012,8.974,9.7v-14.46c0-3.343-.763-4.36-4.4-4.4v-.945c1.671.036,3.379.072,5.05.072,1.417,0,2.8-.072,4.215-.073v.945c-2.216,0-3.415.181-3.415,3.742Z",
    transform: "translate(-237.828 -267.425)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M326.594,290.677c0,4.9-.69,6.14-1.672,7.847a6.812,6.812,0,0,1-5.667,3.015c-1.817,0-3.742-.69-3.742-2.434a1.484,1.484,0,0,1,1.526-1.6,1.189,1.189,0,0,1,1.162,1.308c0,.981.908,1.562,1.962,1.562,2.87,0,2.87-4.541,2.87-7.448V272c0-2.543-1.38-2.58-3.306-2.616v-.945c1.708.036,3.379.072,5.014.072,1.671,0,3.342-.036,5.159-.073v.945c-1.926.036-3.306.073-3.306,2.616Z",
    transform: "translate(-261.596 -267.425)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M362.189,285.7a36.9,36.9,0,0,0,2.071,5.3,3.436,3.436,0,0,0,2.8.981v.945c-1.38,0-2.8-.073-4.178-.073-1.78,0-3.524.036-5.3.073v-.945h.654c.908,0,2-.181,2-1.2a9,9,0,0,0-.545-2.107l-1.816-5.268h-8.537l-.8,2.543a17.559,17.559,0,0,0-.981,4.323c0,1.707,1.2,1.635,2.47,1.707h.836v.945c-1.417,0-2.87-.073-4.287-.073-1.453,0-2.943.036-4.4.073v-.945c2.216-.254,2.616-.545,3.524-2.579.581-1.308,1.017-2.725,1.49-4.069l4.65-12.97a11.071,11.071,0,0,0,.763-3.27,3.839,3.839,0,0,0-.073-.945,4.5,4.5,0,0,0,2.107-1.6h.618Zm-12.352-3.778h7.484l-3.887-10.681h-.073Z",
    transform: "translate(-273.907 -266.553)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M408.5,268.443c1.635.072,3.27.072,4.9.072,1.236,0,2.507-.072,4.033-.073,3.742,0,9.119,1.562,9.119,7.23,0,4.287-4,7.266-7.811,7.266-.727,0-1.308-.037-1.854-.037v-1.2a8.8,8.8,0,0,0,1.381.073c3.124,0,4.505-3.088,4.505-5.7,0-5.05-3.525-6.467-5.922-6.467a10.353,10.353,0,0,0-1.6.109V290.24c0,2.543,1.38,2.58,3.342,2.616v.945c-1.78,0-3.342-.073-4.941-.073-1.744,0-3.451.036-5.268.073v-.945c1.926-.036,3.306-.072,3.306-2.616V272.947c0-2.8-.473-3.56-3.2-3.56Z",
    transform: "translate(-304.49 -267.425)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M459.347,267.43a13.166,13.166,0,0,1,12.97,13.079c0,6.648-5.123,13.37-13.079,13.37a13.165,13.165,0,0,1-12.97-13.079C446.268,274.151,451.391,267.43,459.347,267.43Zm.327,25.286c5.3,0,8.647-4.577,8.647-11.154,0-5.522-3.2-12.97-9.409-12.97-5.3,0-8.647,4.578-8.647,11.154C450.264,285.268,453.461,292.716,459.674,292.716Z",
    transform: "translate(-321.98 -266.958)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M519.334,272.329h-.981c-.109-1.962,0-3.27-2.906-3.27h-5.522v20.309c0,2.544,1.38,2.58,3.306,2.616v.945c-1.744,0-3.307-.073-4.905-.073-1.744,0-3.451.036-5.268.073v-.945c1.926-.036,3.306-.072,3.306-2.616V269.059h-4.759c-3.27,0-3.415.909-4.033,3.27h-.945l.4-5.776h.727c.4.981,1.38,1.017,2.289,1.017h16.494c1.308,0,2.216-.327,2.362-1.017h.763Z",
    transform: "translate(-345.237 -266.553)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M564.118,293.334c-3.851,0-8.284-.073-11.481-.073-3.779,0-7.63.073-11.408.073l18.238-23.869H547.7c-3.27,0-4,2-4.5,3.815h-.872a40.413,40.413,0,0,0,1.09-5.849h.945a.607.607,0,0,0,.4.436,1.614,1.614,0,0,0,.545.109h19.473l-18.165,23.869h10.608c5.159,0,6.249-1.126,7.775-4.9l.8.218Z",
    transform: "translate(-365.834 -266.958)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M596.576,279.923h4.8c2.943,0,2.943-2.289,3.052-3.124h.726c-.072.8-.145,2.761-.145,4.069,0,1.162.181,2.87.145,4.033h-.726c0-3.487-1.163-3.487-3.961-3.487h-3.887v6.176c0,4.033.145,5.05,3.742,5.05h2.252c3.561-.182,5.159-.654,6.576-4.541l.872.145a48.159,48.159,0,0,0-1.489,5.558c-3.633,0-7.266-.073-10.9-.073-2.688,0-5.376,0-8.065.073v-.945c3.161,0,3.452-.581,3.452-4.1V272.62c0-2.979-.582-3.124-3.452-3.233v-.945c2.434.072,4.905.072,7.339.072,3.488,0,6.939,0,10.464-.073v5.414l-.726.181c-.545-3.415-2.18-4.433-5.813-4.433h-4.251Z",
    transform: "translate(-388.155 -267.425)",
    fill: "#1d1d1b",
    stroke: "#1d1d1b",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 40.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M222.986,341.2v.99h-6.565V346.6h5.832v.991h-5.832v5.807h-1.16V341.2Z",
    transform: "translate(-215.261 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M239.422,341.2v12.195h-1.16V341.2Z",
    transform: "translate(-225.883 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M252.359,341.2l7.094,10.316h.034V341.2h1.16v12.195h-1.3l-7.094-10.317h-.034v10.317h-1.16V341.2Z",
    transform: "translate(-231.795 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M287.843,341.2v.99h-7.248V346.6h6.787v.991h-6.787V352.4h7.333v.991h-8.493V341.2Z",
    transform: "translate(-244.897 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M325.033,341.2V350a6.179,6.179,0,0,1-.188,1.622,2.627,2.627,0,0,1-.605,1.128,2.562,2.562,0,0,1-1.091.666,5.353,5.353,0,0,1-1.662.223,3.647,3.647,0,0,1-1.706-.35,2.736,2.736,0,0,1-1.04-.922,3.543,3.543,0,0,1-.511-1.324,8.622,8.622,0,0,1-.137-1.554h1.16q.017.393.051.939a3.227,3.227,0,0,0,.239,1.042,2,2,0,0,0,.673.845,2.271,2.271,0,0,0,1.373.35,3.016,3.016,0,0,0,1.125-.18,1.487,1.487,0,0,0,.7-.564,2.536,2.536,0,0,0,.358-.982,8.629,8.629,0,0,0,.1-1.435v-8.3Z",
    transform: "translate(-262.749 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M349.976,341.2v.99h-7.248V346.6h6.787v.991h-6.787V352.4h7.333v.991h-8.493V341.2Z",
    transform: "translate(-273.591 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M366.131,341.2l2.763,10.675h.034l2.967-10.675h1.45l2.984,10.675h.034l2.78-10.675h1.16l-3.359,12.195h-1.228l-3.087-10.914h-.034l-3.069,10.914h-1.262L364.886,341.2Z",
    transform: "translate(-284.359 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M410.373,341.2v.99h-7.247V346.6h6.787v.991h-6.787V352.4h7.333v.991h-8.493V341.2Z",
    transform: "translate(-301.483 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M427.644,341.2v11.2h6.821v.991h-7.981V341.2Z",
    transform: "translate(-312.805 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M450.8,341.2v11.2h6.821v.991h-7.981V341.2Z",
    transform: "translate(-323.498 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M481.2,341.2v.99H473.95V346.6h6.787v.991H473.95V352.4h7.333v.991H472.79V341.2Z",
    transform: "translate(-334.19 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M502.885,341.2a5.273,5.273,0,0,1,1.424.188,3.448,3.448,0,0,1,1.177.572,2.773,2.773,0,0,1,.8.991,3.2,3.2,0,0,1,.3,1.426,3.427,3.427,0,0,1-.6,2.016,2.724,2.724,0,0,1-1.773,1.093v.034a2.7,2.7,0,0,1,.989.316,1.992,1.992,0,0,1,.64.589,2.437,2.437,0,0,1,.358.828,6.087,6.087,0,0,1,.145,1.017c.011.2.023.455.034.751s.034.6.068.9a5.467,5.467,0,0,0,.162.854,1.62,1.62,0,0,0,.3.623h-1.279a1.514,1.514,0,0,1-.161-.418,3.632,3.632,0,0,1-.086-.512q-.026-.265-.043-.521c-.011-.171-.023-.319-.034-.444q-.035-.649-.111-1.29a3.522,3.522,0,0,0-.325-1.144,2.013,2.013,0,0,0-.716-.812,2.165,2.165,0,0,0-1.287-.273h-4.4v5.414h-1.16V341.2Zm-.085,5.79a3.09,3.09,0,0,0,1.006-.163,2.494,2.494,0,0,0,.836-.469,2.294,2.294,0,0,0,.571-.743,2.237,2.237,0,0,0,.214-1,2.4,2.4,0,0,0-.649-1.777,2.688,2.688,0,0,0-1.978-.649h-4.331v4.8Z",
    transform: "translate(-345.513 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M521.327,341.2h1.364l4.008,6.183,3.99-6.183h1.381l-4.809,7.174v5.021H526.1v-5.021Z",
    transform: "translate(-356.605 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M565.9,341.2v11.2h6.82v.991h-7.981V341.2Z",
    transform: "translate(-376.652 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M592.3,341.2v.99h-4.246v11.2H586.9v-11.2h-4.229v-.99Z",
    transform: "translate(-384.932 -341.199)",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M613.1,341.2a5.683,5.683,0,0,1,4.186,1.562,8.009,8.009,0,0,1,0,9.07,5.684,5.684,0,0,1-4.186,1.563h-4.212V341.2Zm-.58,11.2a7.981,7.981,0,0,0,2.26-.281,3.618,3.618,0,0,0,1.56-.9,3.694,3.694,0,0,0,.9-1.589,9.585,9.585,0,0,0,0-4.68,3.692,3.692,0,0,0-.9-1.588,3.624,3.624,0,0,0-1.56-.9,8,8,0,0,0-2.26-.281h-2.472V352.4Z",
    transform: "translate(-397.039 -341.199)",
    fill: "#1d1d1b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApLogo);
export default __webpack_public_path__ + "static/media/ap-logo.6bf0e0927008cc44b51990f1dc61da2f.svg";
export { ForwardRef as ReactComponent };